import React, { forwardRef, useContext } from 'react';

import { Grid as AntGrid } from 'antd';

import { MyTableContext } from '..';

interface IProps {
  responsive?: boolean;
  children?: React.ReactNode;
}

const MyTableBody = forwardRef<any, IProps>(({ children }, ref) => {
  const { responsive } = useContext(MyTableContext);
  const screens = AntGrid.useBreakpoint();
  const isDesktop = !!screens.md;

  if (!responsive || isDesktop) {
    return (
      <tbody ref={ref} className='text-sm font-normal'>
        {children}
      </tbody>
    );
  }

  return (
    <div ref={ref} className='text-sm font-normal'>
      {children}
    </div>
  );
});

export default MyTableBody;
